export const NAVIGATION_ENTRY = 'navigation';
export const RESOURCE_ENTRY = 'resource';
